export enum AmaronSpecificBehaviourWorkspaceCapabilityAccessOperation {
    create = "f1f4d1d4-0ef8-4b5c-a391-3071e9d6fd18",
    read = "6d535d5c-69d5-4b59-a828-00450c71c8a3",
    update = "d63a23d3-2b7c-4a93-b111-279ddd712895",
    delete = "b5149842-eb0d-4a64-a35c-a217402114bd",
}
